import styled from 'styled-components';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import DamImage from '../../../../../../common/atoms/DamImage';
import Button from '../../../../../../common/atoms/Button';

export const StyledColorPill = styled(DamImage)`
  width: 24px;
  border-radius: 30px;
  ${({ selected }) => (selected ? 'width: 38px' : '')};
  ${({ selected }) => (selected ? 'border-radius: 30px' : '')};
  ${({ selected }) => (selected ? 'border: 2px solid #000;' : '')};
  &.white-color {
    border: #c5c5c5 solid 1px;
  }
  &.outline {
    border-radius: 30px;
    border: 1px solid #000;
  }
`;

export const StyledPillWrapper = styled(Button)`
  min-height: 0;
  padding: 0;
  border: 0;
  background-color: #fff;
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 150px;
  text-transform: none;
  &:focus {
    background-color: #fff !important;
  }
`;

export const StyledPillContainer = styled.div`
  margin: 7px 0;
  text-align: center;
`;

export const StyledColorName = styled(BodyCopy)`
  letter-spacing: 0.1px;
  line-height: 150%;
`;
